















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MarkerDetails extends Vue {
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: true }) readonly postTransit!: string;
  @Prop({ required: true }) readonly postAirplane!: string;
  @Prop({ required: true }) readonly preTransit!: string;
  @Prop({ required: true }) readonly preAirplane!: string;
  @Prop({ required: true }) readonly car!: number;
  @Prop({ required: true }) readonly airplane!: number;
  @Prop({ required: true }) readonly transit!: number;
  @Prop({ required: true }) readonly travelType!: string;
  @Prop({ required: true }) readonly id!: string;
  @Prop({ default: '' }) readonly selectedMarkerId!: string;
  @Prop({ required: true }) readonly lat!: number;
  @Prop({ required: true }) readonly lng!: number;
}
